<div class="as-footer-container">
  <mat-divider></mat-divider>
  <div
    class="as-first-row as-font-bold as-font-black-gray as-font-11 as-font-underline"
  >
    @for (link of linksFooter; track link) {
    <a
      [href]="link.route"
      target="_blank"
      routerLinkActive="router-link-active"
      class="as-pointer"
      (click)="onNavigate()"
    >
      {{ link.label | translate }}
    </a>
    }
  </div>

  <div class="as-second-row as-font-gray-75 as-font-12">
    <mat-label
      >{{ 'FOOTER.copy' | translate }} {{ year }}
      {{ 'FOOTER.copyright' | translate }}
    </mat-label>
  </div>
</div>
